export function getErrorMessage(error: unknown) {
    if (error instanceof Error) {
        return error.message;
    }
    return String(error);
}

export function deriveErrorFromUnknown(error: unknown): Error {
    if (error instanceof Error) {
        return error;
    }
    return new Error(getErrorMessage(error));
}
